import { render, staticRenderFns } from "./NewWorkShift.vue?vue&type=template&id=a85bbc68&scoped=true&"
import script from "./NewWorkShift.vue?vue&type=script&lang=js&"
export * from "./NewWorkShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85bbc68",
  null
  
)

export default component.exports